<template>
	<customDialog :title="'活畜交易近六月价格变化'" :visible='dialogVisible' width='60%' v-if='dialogVisible' @close='onClose'>
		<template v-slot:dialogBody>
			<div id='lineChart'></div>
		</template>
	</customDialog>
</template>
<script>
	import customDialog from '../../components/customDialog.vue'
	import {
		queryQuotationsDetail
	} from "@/api/wms/index.js";
	export default {
		components: {
			customDialog
		},
		props: {
			title: {
				typeof: String,
				default: '',
			},
			sourceType: {
				typeof: [String, Number],
				default: 1,
			},
			visible: {
				typeof: Boolean,
				default: false
			},
			marketInfo: {
				typeof: Object,
				default: () => {}
			},
			transactionType:{
				typeof: String,
				default: '',
			},
			areaId:{
				typeof: String,
				default: '',
			},
		},
		data() {
			return {
				dialogVisible:false,
				
			}
		},
		watch: {},
		created() {
			this.dialogVisible=this.visible
			console.log(this.marketInfo)
			this.getMarketInfo()
		},
		methods: {
			onClose(){
				console.log('关闭11')
				this.dialogVisible=false
				this.$emit('close')
			},
			getMarketInfo() {
				let params = {
					"quotationsDetailId": this.marketInfo.quotationsDetailId,
					"areaId": this.areaId,
					"quotationsTypeId": this.transactionType,
					"appId": "2078",
				}
				queryQuotationsDetail(params).then(res => {
					if(res.status==200&&res.data.code==200&&res.data.result&&res.data.result.xmbQuotationsDetails.length>0){
						console.log(res.data.result.xmbQuotationsDetails)
						let xAxisData=[]
						let YAxisData=[]
						res.data.result.xmbQuotationsDetails.forEach(item=>{
							xAxisData.unshift(item.quotationsDate)
							YAxisData.unshift(item.price)
						})
						
						this.lineChart({
						  dom: 'lineChart',
						  xAxis: xAxisData,
						  data: YAxisData
						})
					}
					
				})
			},
			lineChart(data) {
			  this.chart = this.$echarts.init(document.getElementById(data.dom))
			  this.chart.setOption({
			    color: ['rgba(146, 208, 65, 1)'],
			    title: {
			      text: '',
			    },
			    tooltip: {
			      trigger: 'axis',
			      backgroundColor: 'rgba(255,255,255,0.8)',
			      borderColor: '#292929',
			      borderWidth: 1,
			      textStyle: {
			        color: '#EFAB44',
			      },
			      formatter: function (params) {
			        let dom = ''
			        console.log(data)
			        params.forEach((item) => {
			          dom += `<p>${item.seriesName}： ${item.value}元/kg</p>`
			        })
			        return `<div>${dom}</div>`
			      },
			    },
			    grid: {
			      left: '0%',
			      right: '5%',
			      bottom: '0%',
			      containLabel: true,
			    },
			    xAxis: [
			      {
			        type: 'category',
			        boundaryGap: true,
			        axisLabel: {
			          color: 'rgba(255, 255, 255, 1)',
			        },
			        axisLine: {
			          show: true, // X轴 网格线 颜色类型的修改
			          symbol: ['none', 'arrow'],
			          symbolSize: [6, 6],
			          lineStyle: {
			            color: 'rgba(255, 255, 255, 0.15)',
			          },
			          interval: 0,
			        },
			        axisTick: {
			          // X轴线 刻度线
			          show: false,
			        },
			        data: data.xAxis,
			      },
			    ],
			    yAxis: [
			      {
			        name: '单位:元/kg',
			        nameTextStyle: {
			          color: 'rgba(255, 255, 255, 1)',
			          padding: [1, 1],
			        },
			        type: 'value',
			        axisLine: {
			          symbol: ['none', 'arrow'],
			          symbolSize: [6, 6],
			          show: true,
			          lineStyle: {
			            color: 'rgba(255, 255, 255, 0.15)',
			          },
			        },
			        splitLine: {
			          lineStyle: {
			            type: 'dashed',
			            color: 'rgba(255,255,255,0.05)',
			          },
			        },
			        axisLabel: {
			          color: 'rgba(255, 255, 255, 1)',
			        },
			      },
			    ],
			    series: [
			      {
			        name: '交易均价',
			        type: 'line',
			        lineStyle: {
			          width: 1,
			        },
			        smooth: true,
			        showSymbol: false,
			        areaStyle: {
			          opacity: 0.8,
			          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
			            {
			              offset: 1,
			              color: 'rgba(146, 208, 65, 0)',
			            },
			            {
			              offset: 0,
			              color: 'rgba(146, 208, 65, 0.31)',
			            },
			          ]),
			        },
			        data: data.data,
			      },
			    ],
			  })
			},
			
		},
	}
</script>
<style scoped lang="scss">
	#lineChart{
		width: 100%;
		height: 5.4rem;
	}
</style>